import { AppUtil } from 'kuaidong-lib'
import { ExamDrill } from 'kuaidong-model'
import VueRouter, { RouteConfig } from 'vue-router'

const ListUnversity = () => import('../views/exam/ListUniversity.vue')
const Details = () => import('../views/exam/DetailsUniversity.vue')

const EditGeneralUniversity = () => import('../views/exam/EditGeneralUniversity.vue')

const listUniversityRoute: RouteConfig = {
  path: '/exam-list-university',
  name: 'exam_list_university',
  component: ListUnversity,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '测试列表',
  },
}
const detailsUniversityRoute: RouteConfig = {
  path: '/exam-details-university',
  name: 'exam_details_university',
  component: Details,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '测试信息',
  },
}

const editGeneralUniversityRoute: RouteConfig = {
  path: '/exam-edit-general-university',
  name: 'exam_edit_general_university',
  component: EditGeneralUniversity,
  props: (route) => ({
    ...route.query,
    ...route.params,
    currentStep: Number(route.query.currentStep),
    totalSteps: Number(route.query.totalSteps),
  }),
  meta: {
    title: '编辑测试',
    stepTitle: '填写测试信息',
    // nextStep: editDrillUniversityRoute.name,
  },
}

export default [listUniversityRoute, detailsUniversityRoute, editGeneralUniversityRoute]

export function navigateToExamEditUniversityGeneral(router: VueRouter) {
  router.push({ name: editGeneralUniversityRoute.name, query: { currentStep: '1', totalSteps: '3' } })
}

export function navigateToExamDrillStandardScore(router: VueRouter, drill: ExamDrill) {
  AppUtil.jumpUrlNewTab(
    `${process.env.VUE_APP_REPORT_HOST}/about/standard-score/Index/?grade=${drill.grade_no}&gender=${
      drill.gender_scope === 'F' ? 'F' : 'M'
    }&drill=${drill.item_value}`,
    '体测项目评分标准'
  )
}

export function navigateToExamDrillStandardScoreRate() {
  AppUtil.jumpUrlNewTab(`${process.env.VUE_APP_REPORT_HOST}/about/standard-score/Rate`, '体测总体评分标准')
}
